export const ROLES = {
    ADVISOR: 'advisor',
    PRETORIAN: "pretorian",
    PRETORIAN_TUTOR: "tutor",
    PRETORIAN_SUPERVISOR: "checker",
    PRETOR: "pretor"
}